import React from 'react';
import { canAccessApp, canEditApp, canViewApp, isDelegatedUser } from '../../utils/permissions';

const PermissionWrapper = ({ 
  children, 
  appName, 
  requireEdit = false, 
  requireView = false,
  fallback = null,
  showForOwner = true 
}) => {
  // If not in delegated mode and showForOwner is true, always show
  if (!isDelegatedUser() && showForOwner) {
    return children;
  }
  
  // Check permissions based on requirements
  let hasPermission = true;
  
  if (requireEdit) {
    hasPermission = canEditApp(appName);
  } else if (requireView) {
    hasPermission = canViewApp(appName);
  } else if (appName) {
    hasPermission = canAccessApp(appName);
  }
  
  if (!hasPermission) {
    return fallback;
  }
  
  return children;
};

export default PermissionWrapper; 